<template>
  <div>
    <Layout>
      <!-- <Layout> -->
      <div class="banner-page">
        <img src="img/banner/program-banner.png" alt="Image" />
      </div>

      <div class="breadcrumbs">
        <div class="container">
          <ul>
            <li>
              <a href="/">Beranda</a>
            </li>
            <li>
              <span>Program</span>
            </li>
          </ul>
        </div>
      </div>

      <section class="page-section">
        <div class="container">
          <div class="section-title text-center">
            Program Himpunan dan Penyaluran
          </div>
          <div id="categories" class="categories mt-3 mb-3">
            <ul>
              <li><a href="/program">Semua</a></li>
              <li>
                <a href="/program?categories=1"
                  >Infrastruktur Masjed</a
                >
              </li>
              <li>
                <a href="/program?categories=2">Fasilitas Masjed</a>
              </li>
              <li>
                <a href="/program?categories=3">Sosial & Keumatan</a>
              </li>
              <li>
                <a href="/program?categories=4"
                  >Pemberdayaan Ekonomi</a
                >
              </li>
              <li>
                <a href="/program?categories=5"
                  >Pendidikan & Dakwah</a
                >
              </li>
              <li>
                <a href="/program?categories=6">Lingkungan Masjed</a>
              </li>
              <li>
                <a href="/program?categories=7"
                  >Kesejahteraan Masjed</a
                >
              </li>
            </ul>
          </div>
          <div v-if="newData.length === 0">
            <div class="program-container mt-32">
              <div v-for="data in skeleton" :key="data.id">
                <div
                  id="loader-program"
                  name="loader-program"
                  class="program-wrapper link-block"
                  style="padding-bottom: 16px;"
                >
                  <div class="placeholder-item"></div>
                  <div
                    class="placeholder-title mt-16"
                    style="width: 95%;"
                  ></div>
                  <div
                    class="placeholder-title mt-16"
                    style="width: 70%;"
                  ></div>
                  <div
                    class="placeholder-title mt-16"
                    style="width: 85%;"
                  ></div>
                </div>
              </div>
            </div>
          </div>
          <div class="program-container mt-32">
            <campaign
              v-for="row in newData"
              :key="row.id"
              :data="row"
            ></campaign>
          </div>
          <div v-if="isLoading === true">
            <div class="program-container mt-32">
              <div v-for="data in skeleton" :key="data.id">
                <div
                  id="loader-program"
                  name="loader-program"
                  class="program-wrapper link-block"
                  style="padding-bottom: 16px;"
                >
                  <div class="placeholder-item"></div>
                  <div
                    class="placeholder-title mt-16"
                    style="width: 95%;"
                  ></div>
                  <div
                    class="placeholder-title mt-16"
                    style="width: 70%;"
                  ></div>
                  <div
                    class="placeholder-title mt-16"
                    style="width: 85%;"
                  ></div>
                </div>
              </div>
            </div>
          </div>
          <div>
            <button
              type="button"
              class="btn btn-cta btn-center"
              @click="loadMore"
              v-if="newData.length > 0"
              :disabled="isLoading"
            >
              {{ buttonText }}
            </button>
          </div>
        </div>
      </section>
      <!-- </Layout> -->

      <slot
    /></Layout>
    <MenuFloat />
  </div>
</template>

<script>
import Layout from '../views/layouts/Index.vue';
import axios from '../utils/api';
import Campaign from '../components/Card/Campaign.vue';
import { mapActions } from 'vuex';
import _ from 'lodash';
import MenuFloat from './layouts/Menu.vue';
import $ from 'jquery';
// import Filter from '../components/Filter/Index.vue';

export default {
  name: 'program',
  components: {
    Layout,
    Campaign,
    MenuFloat,
    // Filter,
  },
  data() {
    return {
      data: [],
      newData: [],
      page: 1,
      buttonText: 'Program Lainnya',
      isLoading: false,
      skeleton: [
        { id: 1 },
        { id: 2 },
        { id: 3 },
        { id: 4 },
        { id: 5 },
        { id: 6 },
        { id: 7 },
        { id: 8 },
        { id: 9 },
      ],
      link: {
        program: 'https://masjed.id/app/site/index',
        carimasjid: 'https://masjed.id/app/site/index',
      },
    };
  },
  created() {
    if (!this.isMobile()) {
      this.link = {
        program: '/program',
        carimasjid: '/cari-masjid',
      };
    }
  },
  mounted() {
    const { categories } = this.$route.query;

    var path = window.location.href; // because the 'href' property of the DOM element is the absolute path
    $('ul a').each(function() {
      if (this.href === path) {
        $(this).addClass('active');
      }
    });

    this.fetchProgram();
    this.resetForm();

    if (categories >= 5) {
      $('#categories').scrollLeft(1000);
    }
    // this.getNextProgram();
  },
  methods: {
    ...mapActions('transactions', ['resetForm']),
    isMobile() {
      if (screen.width <= 760) {
        return true;
      } else {
        return false;
      }
    },
    async fetchProgram() {
      const { categories } = this.$route.query;
      const campaigns = await axios.get(
        `/getcampaign?page=1&limit=9&kategori=${categories || ''}`
      );
      const { data } = campaigns.data;
      this.data = data;

      this.data.forEach((element) => {
        this.newData.push(element.campaign);
      });
    },
    getNextProgram() {
      window.onscroll = async () => {
        let bottomOfWindow =
          document.documentElement.scrollTop + window.innerHeight ===
          document.documentElement.offsetHeight;
        if (bottomOfWindow) {
          this.loadMore();
        }
      };
    },
    async loadMore() {
      const { categories } = this.$route.query;

      this.page = this.page + 1;
      let url = `/getcampaign?page=${
        this.page
      }&limit=9&kategori=${categories || ''}`;
      this.isLoading = true;
      this.buttonText = 'Loading...';
      const nextData = await axios.get(url);

      const { data } = nextData.data;
      if (data.length > 0) {
        data.forEach((element) => {
          if (!_.find(this.newData, { id: element.campaign.id })) {
            this.newData.push(element.campaign);
          }
        });
      }
      this.isLoading = false;
      this.buttonText = 'Program Lainnya';
    },
  },
};
</script>

<style lang="scss" scoped>
.btn-center {
  display: block;
  position: relative;
  margin: 0 auto;
  margin-top: 40px;
}
.placeholder-item {
  box-shadow: 0 4px 10px 0 rgba(33, 33, 33, 0.15);
  border-radius: 4px;
  height: 200px;
  width: 100%;
  position: relative;
  overflow: hidden;
}
.placeholder-item::before {
  content: '';
  display: block;
  position: absolute;
  left: -150px;
  top: 0;
  height: 100%;
  width: 150px;
  background: linear-gradient(
    to right,
    transparent 0%,
    #e8e8e8 50%,
    transparent 100%
  );
  animation: load 1s cubic-bezier(0.4, 0, 0.2, 1) infinite;
}

.placeholder-title {
  margin: 8px;
  box-shadow: 0 4px 10px 0 rgba(33, 33, 33, 0.15);
  border-radius: 4px;
  height: 15px;
  width: 50%;
  position: relative;
  overflow: hidden;
}
.placeholder-title:before {
  content: '';
  display: block;
  position: absolute;
  left: -150px;
  top: 0;
  height: 100%;
  width: 150px;
  background: linear-gradient(
    to right,
    transparent 0%,
    #e8e8e8 50%,
    transparent 100%
  );
  animation: load 1s cubic-bezier(0.4, 0, 0.2, 1) infinite;
}
@keyframes load {
  from {
    left: -150px;
  }
  to {
    left: 100%;
  }
}

.categories {
  width: 100%;
  overflow: auto;

  /* width */
  &::-webkit-scrollbar {
    width: 3px;
    height: 3px;
  }

  /* Track */
  &::-webkit-scrollbar-track {
    border-radius: 5px;
    background: #f4f4f4;
  }

  /* Handle */
  &::-webkit-scrollbar-thumb {
    background: #28a745;
    border-radius: 20px;
    max-height: 10px;
  }

  /* Handle on hover */
  &::-webkit-scrollbar-thumb:hover {
    background: #28a745;
  }

  ul {
    width: 155%;
    list-style-type: none;
    display: flex;
    li {
      a {
        display: block;
        text-decoration: none;
        border: 2px solid #f4f4f4;
        margin-right: 10px;
        padding: 10px 20px;
        border-radius: 30px;
        color: #28a745;
        font-weight: bold;
      }

      a.active {
        border: 2px solid #28a745;
        background: #28a745;
        color: #ffffff;
      }
    }
  }
}
</style>
